/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {DeadwoodRip} from "../../DeadwoodRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class BreakBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", false);
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.brokeTheBank;
    }

    protected async createWinAnimation():Promise<any> {
        DeadwoodRip.xBetController.featureVisible = false;

        const tl = gsap.timeline();
        let delay = 0.1;
        if(DeadwoodRip.model.parsedGameData.singleWin > 0) {
            delay += 0.3;
        }
        tl.to(this, {duration : delay});
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            DeadwoodRip.winCapScreen.show(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
                resolve();
            });
        });
    }
}